import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "sticky-column" }
const _hoisted_4 = {
  key: 0,
  class: "is-flex is-justify-content-center is-align-items-center",
  style: {"height":"120px"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "pdf-container"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = {
  key: 1,
  class: "image-container",
  title: "Click to enlarge Image"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 4 }
const _hoisted_13 = ["title"]
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 3,
  class: "modal is-active image-modal"
}
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { ref: "imageZoomContainer" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 4,
  class: "modal is-active pdf-modal"
}
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 5,
  class: "modal is-active video-modal"
}
const _hoisted_26 = { class: "modal-content" }
const _hoisted_27 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.fileData.file_description), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.fileData.file_type), 1)
    ]),
    (_ctx.getAccessType !== 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(_ctx.formatFileSize(_ctx.fileData.file_size)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.getAccessType !== 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.fileData.upload_time), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[16] || (_cache[16] = [
            _createElementVNode("div", { class: "spinner" }, null, -1)
          ])))
        : (_ctx.isVideo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!_ctx.videoBlobUrl && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "icon-wrapper has-text-primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadBlob && _ctx.loadBlob(...args))),
                    title: "Load Video"
                  }, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "fas fa-play-circle fa-2x" }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "video-preview",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openVideoModal && _ctx.openVideoModal(...args))),
                    title: "Click to enlarge Video"
                  }, [
                    _createElementVNode("video", {
                      ref: "videoPlayer",
                      src: _ctx.videoBlobUrl,
                      autoplay: "",
                      muted: "",
                      playsinline: "",
                      preload: "metadata",
                      style: {"max-width":"100%","height":"auto"},
                      onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 40, _hoisted_6)
                  ]))
            ]))
          : (_ctx.isPdf)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!_ctx.pdfBlobUrl && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "icon-wrapper has-text-primary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadBlob && _ctx.loadBlob(...args))),
                      title: "Load PDF"
                    }, _cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "fas fa-file-pdf fa-2x" }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openPdfModal && _ctx.openPdfModal(...args))),
                      class: "pdf-container",
                      title: "Click to enlarge PDF"
                    }, [
                      _createElementVNode("iframe", {
                        src: _ctx.pdfBlobUrl,
                        width: "200",
                        height: "100"
                      }, null, 8, _hoisted_8)
                    ]))
              ]))
            : (_ctx.isImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!_ctx.imageBlobUrl && !_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "icon-wrapper has-text-primary",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.loadBlob && _ctx.loadBlob(...args))),
                        title: "Load Image"
                      }, _cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "fas fa-image fa-2x" }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: _ctx.imageBlobUrl,
                          alt: "Preview",
                          style: {"max-width":"200px","height":"auto","cursor":"zoom-in"},
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args))),
                          onContextmenu: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                        }, null, 40, _hoisted_11)
                      ]))
                ]))
              : (!_ctx.isVideo && !_ctx.isPdf && !_ctx.isImage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "icon-wrapper has-text-primary",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadFileHandler && _ctx.downloadFileHandler(...args)), ["prevent"])),
                      title: _ctx.$t('FilesData.Download')
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.getFileIcon(_ctx.fileData.file_name), "fa-2x"])
                      }, null, 2)
                    ], 8, _hoisted_13)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('FilesData.Loading')), 1))
    ]),
    (_ctx.getAccessType !== 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.getEditingSpecialty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "button is-danger is-small",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
                  }, " Delete ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showImageModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", {
            class: "modal-background",
            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
          }),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("img", {
                src: _ctx.imageBlobUrl,
                alt: "Full-size image",
                class: "full-image",
                onContextmenu: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
              }, null, 40, _hoisted_21)
            ], 512)
          ]),
          _createElementVNode("button", {
            class: "modal-close is-large",
            "aria-label": "close",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeImageModal && _ctx.closeImageModal(...args)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPdfModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("iframe", {
              src: _ctx.pdfBlobUrl,
              style: {"border":"none","width":"100%","height":"100%"}
            }, null, 8, _hoisted_24)
          ]),
          _createElementVNode("button", {
            class: "modal-close is-large",
            "aria-label": "close",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showVideoModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("video", {
              ref: "modalVideoPlayer",
              src: _ctx.videoBlobUrl,
              controls: "",
              autoplay: "",
              muted: "",
              playsinline: "",
              controlsList: "nodownload",
              style: {"width":"100%","height":"100%"},
              onContextmenu: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
            }, null, 40, _hoisted_27)
          ]),
          _createElementVNode("button", {
            class: "modal-close is-large",
            "aria-label": "close",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeVideoModal && _ctx.closeVideoModal(...args)))
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}